import { useState } from "react";
import styles from "./Section10Footer.module.scss";
import TermsConditionsModal from "../common/TermsConditionsModal";
import PrivacyPolicyModal from "../common/PrivacyPolicyModal";
import RefundPolicyModal from "../common/RefundPolicyModal";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
/* ─── SVG icon components ─── */
const LocationIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <rect x="7" y="13" width="3" height="3" rx="0.5" fill="#f59e0b" stroke="none" />
    <rect x="14" y="13" width="3" height="3" rx="0.5" fill="#f59e0b" stroke="none" />
  </svg>
);

const PencilIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const GridIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" stroke="#f59e0b" />
  </svg>
);

const QuestionIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const ChartIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

const FaqIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const ReviewIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
  </svg>
);

const ContactIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const LinkIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0077b5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1877f2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e1306c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const ShieldBigIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#fff7ed" stroke="#f59e0b" strokeWidth="1.5" />
    <path d="M9 12l2 2 4-4" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ─── Tiny sparkline chart (SVG) ─── */
const SparklineChart = () => (
  <svg viewBox="0 0 280 80" className={styles.sparklineSvg}>
    {/* Grid lines */}
    <line x1="0" y1="20" x2="280" y2="20" stroke="#e5e7eb" strokeWidth="0.5" />
    <line x1="0" y1="40" x2="280" y2="40" stroke="#e5e7eb" strokeWidth="0.5" />
    <line x1="0" y1="60" x2="280" y2="60" stroke="#e5e7eb" strokeWidth="0.5" />

    {/* Last Week (dashed) */}
    <polyline
      points="0,55 47,50 94,58 141,45 188,52 235,48 280,42"
      fill="none" stroke="#cbd5e1" strokeWidth="2" strokeDasharray="6 4"
    />

    {/* This Week (solid with dots) */}
    <polyline
      points="0,50 47,38 94,45 141,28 188,20 235,30 280,15"
      fill="none" stroke="#f59e0b" strokeWidth="2.5"
    />
    {[
      [0, 50], [47, 38], [94, 45], [141, 28], [188, 20], [235, 30], [280, 15]
    ].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r="4" fill="#fff" stroke="#f59e0b" strokeWidth="2" />
    ))}

    {/* Day labels */}
    {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d, i) => (
      <text key={d} x={i * 47} y="78" fontSize="10" fill="#94a3b8" textAnchor="start">{d}</text>
    ))}
  </svg>
);

/* ─── Top Profit Driver badge ─── */
const ProfitDriverIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="11" fill="#fff7ed" stroke="#f59e0b" strokeWidth="1" />
    <path d="M7 17v-4m5 4V7m5 10v-6" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/* ════════════════════════════════════════════════════════════════════
   SECTION 10 — FOOTER
   ════════════════════════════════════════════════════════════════════ */
const Section10Footer = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setPrivacyModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const renderQuickLink = (to, icon, label, isRoute = false) => {
    if (isRoute) {
      return (
        <RouterLink to={to} className={styles.quickLinkItem}>
          {icon}<span>{label}</span>
        </RouterLink>
      );
    }
    if (isHomePage) {
      return (
        <ScrollLink
          to={to}
          smooth={true}
          spy={true}
          offset={-90}
          className={styles.quickLinkItem}
          style={{ cursor: 'pointer' }}
        >
          {icon}<span>{label}</span>
        </ScrollLink>
      );
    }
    return (
      <RouterLink to={`/#${to}`} className={styles.quickLinkItem}>
        {icon}<span>{label}</span>
      </RouterLink>
    );
  };

  return (
    <>
      <footer id="contact" className={styles.section10}>
        {/* ── 1. HERO AREA ── */}
        <div className={styles.heroArea}>
          <div className={styles.heroContainer}>
            {/* Left column — branding */}
            <div className={styles.heroLeft}>
              <h2 className={styles.brandTitle}>
                <span className={styles.brandMunafa}>MUNAFA</span>{" "}
                <span className={styles.brandEngine}>ENGINE</span>
              </h2>
              <p className={styles.brandTagline}>WEEKLY PROFIT CLARITY FOR SALON OWNERS</p>
              <div className={styles.brandAccent} />
              <p className={styles.brandDescription}>
                Turn your salon's daily numbers<br />into clearer weekly decisions.
              </p>

              <div className={styles.helpingSection}>
                <h3 className={styles.helpingTitle}>Currently Helping Salon Owners In</h3>
                <div className={styles.locationPills}>
                  {["Mumbai", "Thane", "Pune"].map((city) => (
                    <span className={styles.locationPill} key={city}>
                      <LocationIcon /> {city}
                    </span>
                  ))}
                </div>
              </div>

              <div className={styles.helpingSection} style={{ marginTop: '16px' }}>
                <h3 className={styles.helpingTitle}>Coming Soon to Help Salon Owners In</h3>
                <div className={styles.locationPills}>
                  {["Nagpur", "Ahmedabad", "Indore"].map((city) => (
                    <span className={styles.locationPill} key={city} style={{ opacity: 0.8 }}>
                      <LocationIcon /> {city}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Right column — snapshot card */}
            <div className={styles.heroRight}>
              <div className={styles.snapshotCard}>
                <div className={styles.snapshotHeader}>
                  <CalendarIcon />
                  <div>
                    <h3 className={styles.snapshotTitle}>Your Weekly Clarity Snapshot</h3>
                    <p className={styles.snapshotSubtitle}>See your salon's big picture, every week.</p>
                  </div>
                </div>

                {/* KPI row */}
                <div className={styles.kpiRow}>
                  <div className={styles.kpiItem}>
                    <span className={styles.kpiLabel}>Weekly Profit</span>
                    <span className={styles.kpiValue}>₹24,850</span>
                    <span className={`${styles.kpiChange} ${styles.positive}`}>↑ 18% vs last week</span>
                  </div>
                  <div className={styles.kpiItem}>
                    <span className={styles.kpiLabel}>Revenue</span>
                    <span className={styles.kpiValue}>₹1,48,600</span>
                    <span className={`${styles.kpiChange} ${styles.positive}`}>↑ 12% vs last week</span>
                  </div>
                  <div className={styles.kpiItem}>
                    <span className={styles.kpiLabel}>Expenses</span>
                    <span className={styles.kpiValue}>₹1,05,750</span>
                    <span className={`${styles.kpiChange} ${styles.negative}`}>↓ 5% vs last week</span>
                  </div>
                  <div className={styles.kpiItem}>
                    <span className={styles.kpiLabel}>Net Profit %</span>
                    <span className={styles.kpiValue}>16.7%</span>
                    <span className={`${styles.kpiChange} ${styles.positive}`}>↑ 2.1% vs last week</span>
                  </div>
                </div>

                {/* Chart row */}
                <div className={styles.chartRow}>
                  <div className={styles.chartSection}>
                    <div className={styles.chartHeader}>
                      <span className={styles.chartTitle}>7-Day Profit Trend</span>
                      <div className={styles.chartLegend}>
                        <span className={styles.legendSolid}>— This Week</span>
                        <span className={styles.legendDashed}>-- Last Week</span>
                      </div>
                    </div>
                    <SparklineChart />
                  </div>
                  <div className={styles.driverSection}>
                    <span className={styles.driverLabel}>Top Profit Driver</span>
                    <div className={styles.driverContent}>
                      <ProfitDriverIcon />
                      <div>
                        <span className={styles.driverName}>Hair Services</span>
                        <span className={`${styles.kpiChange} ${styles.positive}`}>+32% vs last week</span>
                      </div>
                    </div>
                    <a href="#" className={styles.viewLink}>View full weekly clarity →</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ── 2. FEATURES BAR ── */}
        <div className={styles.featuresBar}>
          <div className={styles.featuresContainer}>
            <div className={styles.featureItem}>
              <div className={styles.featureIcon}><PencilIcon /></div>
              <div>
                <span className={styles.featureTitle}>Simple Input</span>
                <span className={styles.featureDesc}>Add a few numbers.{"\n"}That's it.</span>
              </div>
            </div>
            <div className={styles.featureDivider} />
            <div className={styles.featureItem}>
              <div className={styles.featureIcon}><GridIcon /></div>
              <div>
                <span className={styles.featureTitle}>Weekly Clarity</span>
                <span className={styles.featureDesc}>Clear insights every week,{"\n"}not every day.</span>
              </div>
            </div>
            <div className={styles.featureDivider} />
            <div className={styles.featureItem}>
              <div className={styles.featureIcon}><ShieldIcon /></div>
              <div>
                <span className={styles.featureTitle}>Private &amp; Confidential</span>
                <span className={styles.featureDesc}>Your data stays safe{"\n"}and always private.</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── 3. QUICK LINKS BAR ── */}
        <div className={styles.quickLinksBar}>
          <div className={styles.quickLinksContainer}>
            <div className={styles.quickLinksLabel}>
              <LinkIcon />
              <span>Quick Links</span>
            </div>
            <div className={styles.quickLinksItems}>
              {renderQuickLink("how-it-works", <QuestionIcon />, "How It Works")}
              {renderQuickLink("what-you-see", <ChartIcon />, <>What You<br />Start Seeing</>)}
              {renderQuickLink("faq", <FaqIcon />, "FAQs")}
              {renderQuickLink("request-review", <ReviewIcon />, <>Request My<br />Review</>)}
              {renderQuickLink("/contact", <ContactIcon />, "Contact Us", true)}
            </div>
          </div>
        </div>

        {/* ── 4. CONTACT BAR ── */}
        <div className={styles.contactBar}>
          <div className={styles.contactContainer}>
            <a href="https://www.linkedin.com/feed/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className={styles.socialLink}>
              <LinkedInIcon />
              <span><strong>LinkedIn:</strong> Munafa Engine</span>
            </a>
            <div className={styles.contactDivider} />
            <a href="https://www.facebook.com/munafaengine" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className={styles.socialLink}>
              <FacebookIcon />
              <span><strong>Facebook:</strong> @munafaengine</span>
            </a>
            <div className={styles.contactDivider} />
            <a href="https://www.instagram.com/munafaengine/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={styles.socialLink}>
              <InstagramIcon />
              <span><strong>Instagram:</strong> @munafaengine</span>
            </a>
            <div className={styles.contactDivider} />
            <div className={styles.contactItem}>
              <MailIcon />
              <span><strong>Email:</strong> connect@munafaengine.com</span>
            </div>
            <div className={styles.contactDivider} />
            <a
              href="https://wa.me/15559303709?text=Hi%20Munafa%20Engine%2C%20I%20want%20to%20know%20more%20about%20weekly%20salon%20clarity."
              target="_blank"
              rel="noopener noreferrer"
              className={styles.whatsappBtn}
            >
              <WhatsAppIcon />
              <span>Chat on WhatsApp</span>
            </a>
          </div>
        </div>

        {/* ── 5. BOTTOM FOOTER ── */}
        <div className={styles.bottomFooter}>
          <div className={styles.bottomContainer}>
            <div className={styles.bottomTop}>
              <div className={styles.trustBadge}>
                <ShieldBigIcon />
                <p>
                  <strong>Your salon data is handled<br />privately and confidentially.</strong>
                </p>
              </div>
              <div className={styles.legalLinks}>
                <button
                  onClick={() => setIsTermsModalOpen(true)}
                  className={styles.legalLink}
                >
                  Terms &amp; Conditions
                </button>
                <span className={styles.legalSep}>|</span>
                <button
                  onClick={() => setPrivacyModalOpen(true)}
                  className={styles.legalLink}
                >
                  Privacy Policy
                </button>
                <span className={styles.legalSep}>|</span>
                <button
                  onClick={() => setIsRefundModalOpen(true)}
                  className={styles.legalLink}
                >
                  Refund &amp; Cancellation Policy
                </button>
              </div>
            </div>
            <p className={styles.copyright}>Copyright © 2026 Munafa Engine. All rights reserved..</p>
          </div>
        </div>
      </footer>
      <TermsConditionsModal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
        onOpenPrivacy={() => {
          setIsTermsModalOpen(false);
          setPrivacyModalOpen(true);
        }}
        onOpenRefund={() => {
          setIsTermsModalOpen(false);
          setIsRefundModalOpen(true);
        }}
      />
      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setPrivacyModalOpen(false)}
        onOpenTerms={() => {
          setPrivacyModalOpen(false);
          setIsTermsModalOpen(true);
        }}
        onOpenRefund={() => {
          setPrivacyModalOpen(false);
          setIsRefundModalOpen(true);
        }}
      />
      <RefundPolicyModal
        isOpen={isRefundModalOpen}
        onClose={() => setIsRefundModalOpen(false)}
        onOpenTerms={() => {
          setIsRefundModalOpen(false);
          setIsTermsModalOpen(true);
        }}
        onOpenPrivacy={() => {
          setIsRefundModalOpen(false);
          setPrivacyModalOpen(true);
        }}
      />
    </>
  );
};

export default Section10Footer;
